<template>
  <div>
    <el-card shadow="always">
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <el-date-picker v-model="params.date_range" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" style="width: 220px"> </el-date-picker>
          <el-button size="mini" icon="el-icon-refresh" style="width: 80px; margin: 0 2px">刷新</el-button>
        </div>
      </div>
    </el-card>
    <el-card shadow="always" class="mt10">
      <el-row :gutter="20">
        <el-col :span="8">
          <echarts :data="visitData" title="客户来访" color="#409EFF"></echarts>
        </el-col>
        <el-col :span="8">
          <echarts :data="succData" title="成交客户" color="#67C23A"></echarts>
        </el-col>
        <el-col :span="8">
          <echarts :data="receiptData" title="回款金额" color="#E6A23C" yAxis="金额" unit="元"></echarts>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import moment from 'moment';
import Echarts from '@/components/report/echarts';
export default {
  name: 'reportIndex',
  components: {
    Echarts
  },
  created() {},
  mounted() {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]);
            }
          },
          {
            text: '上月',
            onClick(picker) {
              picker.$emit('pick', [moment().clone().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), moment().clone().startOf('month').subtract(1, 'days').format('YYYY-MM-DD')]);
            }
          },
          {
            text: '本季',
            onClick(picker) {
              const startDate = moment(moment().quarter(moment().quarter()).startOf('quarter').valueOf()).format('YYYY-MM-DD');
              picker.$emit('pick', [startDate, moment().format('YYYY-MM-DD')]);
            }
          }
        ]
      },
      params: {
        date_range: []
      },
      visitData: [
        // { month: '1月', value: 120 },
        // { month: '2月', value: 200 },
        // { month: '3月', value: 150 },
        // { month: '4月', value: 80 }
      ],
      succData: [],
      receiptData: []
    };
  },
  methods: {}
};
</script>
